import type { TutorialGuidanceDto, ValidatorResult } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class TutorialGuidanceService {
  private readonly crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<TutorialGuidanceDto>('api/tutorial-guidance');
  }

  public getUnviewedGuidance(accountId: string): Promise<ValidatorResult<TutorialGuidanceDto[]>> {
    return this.crudService.do('get', `?unviewed=true&accountId=${accountId}`, undefined, undefined, 'silent');
  }
}
